export default __webpack_public_path__ + "static/media/server-error.1622a966.svg";